import { useQuery } from '@tanstack/react-query';
import type { EnvironmentStage } from '@chatsdet/types';
import { API_URL } from '../../../config';
import { toApiError } from '../../../lib/api-error';

export type EnvironmentStageResponse = {
  stages: EnvironmentStage[];
};

/**
 * The org's environment stages. Caches the full response under
 * `['environment-kinds']` — the same key and shape the stage select and the run
 * config modal use, so every reader shares one cache entry.
 */
export function useEnvironmentStages(enabled = true) {
  return useQuery({
    queryKey: ['environment-kinds'],
    enabled,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<EnvironmentStageResponse> => {
      const response = await fetch(`${API_URL}/org/environment-kinds`, {
        credentials: 'include',
      });
      if (!response.ok) throw await toApiError(response, 'Failed to fetch stages');
      return response.json();
    },
  });
}
